import { render, staticRenderFns } from "./ApiBatchList.vue?vue&type=template&id=37271a72&"
import script from "./ApiBatchList.vue?vue&type=script&lang=js&"
export * from "./ApiBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports